const Menu = (props) => {
    return (
        <div className="mr-1">
            <button className={props.selected?"obtn bg-primary tx-white":"obtn bg-secondary tx-white"} onClick={() => props.callback(props.data)} style={{minHeight: "100%"}}>
                {props.data.name}
            </button>
        </div>
    );
}

export default Menu;